// removed by extract-text-webpack-plugin
module.exports = {"Box":"_1o69KHILT7-GAQht_VqYnt","Warning":"_3IwMzJ7Y6HpqYUc4xLDLxx","Error":"_309KrEZd-gzRqPK0AmKURs","Success":"_1P4vK5zZUESSlH17qr5KsV","Info":"_3rHbjetip04j-uEUKZ0Prj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Message/styles.css
// module id = 654
// module chunks = 0